var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-item"},[_c('SubNav',{attrs:{"tab":_vm.tab},on:{"change":_vm.setTab}}),(_vm.tab)?[_c('LeaderboardUsers',{attrs:{"tab":_vm.tab}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }